const campaignAdditionalFieldTransformer = response => {
  const fields = response?.campaignData?.SocialCampaignFieldMappings?.filter(({ showOnForm }) => showOnForm) || []
  const mapField = field => ({
    id: field?.inquiryFieldId?.toString(),
    value: field?.defaultValue,
    label: field?.ExternalInquiryField?.label,
    isRequired: field?.mandatory,
    isEditable: field?.valuesEditable,
    componentType: field?.ExternalInquiryField?.FieldType?.key,
    fieldSlug: field?.ExternalInquiryField?.key,
    isAdditional: field?.isAdditional,
  })

  return {
    mandatoryFields: fields.filter(({ mandatory }) => mandatory).map(mapField),
    nonMandatoryFields: fields.filter(({ mandatory }) => !mandatory).map(mapField),
    hasFields: !!fields?.length,
  }
}

export default campaignAdditionalFieldTransformer
